<template>
    <div class="firstRechargePage">
    <CustomHeader :text="$t('activityName.first_recharge')" :show-history="true" @openHistoryPopup="openHistoryPopup" />
    <img class="bg-top-img" :src="dataSet.bannerIcon">
    <div class="firstRecharge">
        <div class="firstRecharge-left">
            <img src="@/assets/firstRecharge/walletFR2.png" class="wallet-icon" />
            <span class="firstRecharge-label">{{ $t('activity.firstRecharge') }}:</span>
        </div>
        <span class="firstRecharge-amount">R$ {{ formatCurrency(dataSet.firstRechargeAmount) }}</span>
    </div>
    <div class="container">
        <img v-if="dataSet.showLeft" src="@/assets/home/game_arrow_white.png"
            style="width: 5%;position: absolute;top: 2vh; z-index: 200;" @click="scrollLeft">
        <img v-if="dataSet.showRight" src="@/assets/home/game_arrow_white.png" @click="scrollRight"
            style="width: 5%;position: absolute;transform: rotate(180deg);right:0;top: 2vh; z-index: 200;">
        <div v-if="dataSet.recordList.length > 0">
            <div class="content">
                <div v-for="(i, index) in dataSet.recordList" :key="index" class="image-wrapper">
                    <DayListFirst :currenyLable="true" :valueOne="i?.coin" :valueTwo="i?.turnover"
                        :labelOne="'dayList.giftAmount'" :labelTwo="'dayList.turnoverTimes'" :activityStatus="i?.status"
                        :time="i?.rewardDate" @getClaim="getClaim" :available-amount="i?.availableAmount"
                        :given-amount="i?.givenAmount" />
                </div>
            </div>
        </div>
        <div class="tabs-container" v-if="dataSet.firstRechargeConfig">
            <van-tabs v-if="dataSet.isShowTabs" v-model:active="active" :ellipsis="false" ref="tabsRef"
                @rendered="checkScroll">
                <van-tab v-for="(item, index) in dataSet.firstRechargeConfig?.config" :key="index" :title="item.title"
                    :name="index">
                    <div class="content">
                        <div class="immidiateDepositBtn"  v-if="dataSet.firstRechargeConfig?.firstRechargeEligible">
                            <div class="depositBtn" @click="goToDeposit(item.amount)">
                                <img src="@/assets/firstRecharge/DepoBtnFR2.png" class="btn-icon-image" />
                                <span class="btn-text">{{ $t('activity.immediateDeposit') }} : {{ item.amount }}</span>
                                <van-icon name="arrow" class="arrow-right" />
                            </div>
                        </div>
                        <div v-for="(i, index) in item.days" :key="index" class="image-wrapper">
                            <DayListFirst :currenyLable="true" :day="i.day" :valueOne="i.gift ? i.gift : 0"
                                :valueTwo="i.turnover_times" :labelOne="'dayList.giftAmount'"
                                :labelTwo="'dayList.turnoverTimes'" :activityStatus="i.activeStatus" />
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
            <div v-else v-for="(item, index) in dataSet.firstRechargeConfig?.config" :key="index" :title="item?.title"
                :name="index">
                <div class="content">
                    <div v-for="(i, index) in item?.days" :key="index" class="image-wrapper">
                        <DayListFirst :currenyLable="true" :day="i?.day" :valueOne="i?.gift ? i?.gift : 0"
                            :valueTwo="i?.turnover_times" :labelOne="'dayList.giftAmount'"
                            :labelTwo="'dayList.turnoverTimes'" :activityStatus="i?.activeStatus" />
                    </div>
                </div>
            </div>
        </div>
        <NoData v-if="!dataSet.firstRechargeConfig && dataSet.recordList.length == 0" />
        <div class="bottom_text">
            <div class="rules-header">
                <span class="decorator"></span>
                <span class="title">{{ $t('common.activityTitle') }}</span>
                <span class="decorator"></span>
            </div>
            <div class="rules-body">
                <div class="line_text" v-for="(item, index) in dataSet.formattedMessages" :key="index" v-html="item">
                </div>
            </div>
        </div>
        <CashbackHistoryPopup ref="histryPopupRef" :list="dataSet.historyList" :title="$t('activity.lossTotal')"
            @resetHistoryData="resetHistoryData" :isUseFirstRecharge="true" :isTabsContainerActive="dataSet.isShowTabs" />
    </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { formatCurrency } from '@/utils/commonFunction';
import CustomHeader from '../components/common/customHeader.vue';
import DayListFirst from './components/dayListFirst.vue';
import NoData from '../components/common/noData.vue';
import CashbackHistoryPopup from './components/cashbackHistoryPopup.vue';
import { FirstRechargeData } from '@/view/firstRecharge/supportScript';

const histryPopupRef = ref()
const active = ref(0);
const props = defineProps<{
    dataSet: FirstRechargeData
}>()

const emits = defineEmits(['checkScroll', 'scrollLeft', 'scrollRight', 'getClaim', 'goToDeposit'])

const setActive = (value : number) => {
    active.value = value
}

const checkScroll = () => {
    emits('checkScroll')
};

const scrollLeft = () => {
    emits('scrollLeft')
};

const scrollRight = () => {
    emits('scrollRight')
};

const getClaim = () => {
    emits('getClaim')
}
const goToDeposit = (amount : any) => {
     emits("goToDeposit", amount)
}

const openHistoryPopup = (data: any) => {
    histryPopupRef.value.open(data)
}
const resetHistoryData = () => {
    // historyList.value = []
}
defineExpose({
    setActive
})
</script>
<style scoped>
.firstRechargePage {
    background-color: #0c0114;
    min-height: 100vh;
}

.firstRecharge {
    margin: 10px 15px;
    padding: 15px 15px;
    background: linear-gradient(90deg, #320860 0%, #420250 100%);
    border: 1px solid #8f1c8f;
    box-shadow: 0 0 10px rgba(247, 68, 219, 0.2); 
    animation: pulse 2s infinite;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 10;
}

.firstRecharge-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.wallet-icon {
    width: 50px;
    height: 50px;
    background: linear-gradient(180deg, #dc7be7 0%, #e54fe0 100%);
    border-radius: 10px;
    padding: 4px;
    box-sizing: border-box;
    object-fit: contain;
}

.firstRecharge-label {
    color: #e6d1fb;
    font-size: 14px;
}

.firstRecharge-amount {
    color: #f744db;
    font-size: 20px;
    font-weight: bold;
}

.container {
    padding: 0px;
    position: relative;

}

.tabs-container {
    margin: 0 15px 20px;
    border: 1px solid rgba(247, 68, 219, 0.25); 
    border-radius: 16px;
    background: linear-gradient(180deg, rgba(30, 4, 45, 0.7) 0%, rgba(12, 1, 20, 0.9) 100%);
    overflow: hidden;
    backdrop-filter: blur(12px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}

.tabs-container>>>.van-tabs__nav {
    background: rgba(0, 0, 0, 0.2); 
    margin: 0;
    padding: 0;
}

.tabs-container>>>.van-tab {
    background: transparent;
    color: #b5aabf;
    border-radius: 0;
    font-size: 14px;
    margin: 0;
    height: 52px;
    padding: 0;
    flex: 1;
    border-bottom: 1px solid rgba(247, 68, 219, 0.1);
    transition: all 0.3s ease;
}

.tabs-container>>>.van-tab.van-tab--active {
    color: #f744db;
    font-weight: 600;
    background: linear-gradient(180deg, rgba(247, 68, 219, 0.05) 0%, rgba(247, 68, 219, 0.15) 100%);
    border-bottom: none;
    position: relative;
}

.tabs-container>>>.van-tab.van-tab--active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, #f744db, transparent);
    box-shadow: 0 -2px 8px rgba(247, 68, 219, 0.5);
}

.tabs-container>>>.van-tabs__line {
    background-color: #f744db;
    height: 3px;
    width: 40px !important;
    bottom: 0px;
    border-radius: 3px 3px 0 0;
    box-shadow: 0 -2px 10px rgba(247, 68, 219, 0.8);
}

.content {
    color: #fff;
    padding: 16px;
}

.tabs-container .content {
    background: transparent;
}

.immidiateDepositBtn {
    margin-bottom: 15px;
}

.depositBtn {
    background: linear-gradient(90deg, #db00b9 0%, #692762 100%);
    border-radius: 12px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    box-shadow: 0 4px 15px rgba(247, 68, 219, 0.4);
    transition: all 0.2s ease;
}

.depositBtn:active {
    transform: scale(0.98);
}

.btn-icon-image {
    width: 32px;
    height: 32px;
    object-fit: contain;
    filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3));
}

.btn-text {
    flex: 1;
    margin-left: 12px;
    text-align: left;
    color: #ffffff;
    font-size: 15px;
    font-weight: 500;
    text-shadow: 0 1px 2px rgba(0,0,0,0.3);
}

.arrow-right {
    font-size: 18px;
    color: #ffffff;
    font-weight: bold;
}
.bottom_text {
    margin: 0 15px 30px;
    padding: 24px 20px;
    background: linear-gradient(1deg, rgba(66, 2, 80, 0.8) 0%, rgba(20, 4, 30, 0.95) 100%);
    border-bottom: none;
    border-radius: 16px 16px 0 0;
    box-shadow: 
        0 10px 25px rgba(0, 0, 0, 0.5), 
        inset 0 1px 0 rgba(255, 255, 255, 0.05),
        inset 0 0 20px rgba(247, 68, 219, 0.05);
    position: relative;
    overflow: hidden;
    backdrop-filter: blur(10px);
}

.bottom_text::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(247, 68, 219, 0.6), transparent);
}

.rules-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    margin-bottom: 20px;
}

.title {
    color: #fff;
    font-size: 16px;
    letter-spacing: 1px;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.decorator {
    height: 3px;
    width: 40px;
    background: linear-gradient(90deg, transparent, #f744db);
    border-radius: 3px;
    opacity: 0.8;
}

.rules-body {
    background: rgba(12, 1, 20, 0.6);
    border-radius: 12px;
    padding: 16px;
    border: 1px solid rgba(143, 28, 143, 0.2);
    box-shadow: inset 0 2px 10px rgba(0, 0, 0, 0.3);
}

.line_text {
    color: #84638d;
    font-size: 13px;
    line-height: 1.6;
    margin-bottom: 12px;
    position: relative;
    padding-left: 14px;
    font-weight: 400;
}

.bg-top-img {
    width: 100%;
    padding-top: 3rem;
}

.scroll-btn {
    position: absolute;
    font-size: 24px;
    color: white;
    cursor: pointer;
    z-index: 1000;
    border-radius: 50%;
    user-select: none;

}

.scroll-btn img {
    width: 10%;
    z-index: 200;
}

.scroll-btn.left {
    left: 50vw;
    width: 4%;
}

.scroll-btn.right {
    right: 0;
}

.right img {
    transform: rotate(180deg) !important;
}

@media (max-width: 360px) {
    .firstRecharge-amount {
        font-size: 15px;
    }
    .title {
        font-size: 13px;
    }
    .wallet-icon {
    width: 40px;
    height: 40px;
    
}
}
</style>